export default __webpack_public_path__ + "static/media/CoinRoutes.305ab593.svg";